import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  EVENT: {
    GET_BY_ID: (eventId) => ({ eventId }),
    API: {
      GET_BY_ID: apiResourceActionCreator('event')
    }
  }
})

export const apiAction = (authToken, eventId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/${eventId}`, authToken, action.event.api.getById)

function* getById({ payload }) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, payload.eventId))
}

const configuration = {
  name: 'getById',
  action: action,
  sagas: getById,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      selectedEvent: action.payload.event
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      isLoadingMore: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/event/configurations/getById.js